$(function () {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('.home-hero video[data-hero-video]').forEach(video => {
        const hero = video.closest('.home-hero');
        const menu = document.getElementById('navbarSupportedContent');
        let visible = false;
        let menuOpen = false;

        function updatePlayback() {
            if (!visible || menuOpen || document.hidden || reducedMotion.matches || hero.contains(document.activeElement)) {
                video.pause();
                if (reducedMotion.matches) video.classList.remove('is-playing');
                return;
            }
            if (!video.getAttribute('src')) video.src = video.getAttribute('data-hero-video');
            video.muted = true;
            const playing = video.play();
            if (playing && playing.catch) playing.catch(() => video.classList.remove('is-playing'));
        }

        video.addEventListener('playing', () => video.classList.add('is-playing'));
        video.addEventListener('error', () => video.classList.remove('is-playing'));
        if ('IntersectionObserver' in window) {
            new IntersectionObserver(entries => {
                visible = entries[0].isIntersecting;
                updatePlayback();
            }).observe(hero);
        } else {
            visible = true;
            updatePlayback();
        }
        document.addEventListener('visibilitychange', updatePlayback);
        hero.addEventListener('focusin', updatePlayback);
        hero.addEventListener('focusout', () => setTimeout(updatePlayback, 0));
        if (menu) {
            menu.addEventListener('show.bs.offcanvas', () => { menuOpen = true; updatePlayback(); });
            menu.addEventListener('hidden.bs.offcanvas', () => { menuOpen = false; updatePlayback(); });
        }
        if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', updatePlayback);
        else reducedMotion.addListener(updatePlayback);
    });
});
